import React from "react";
import { Svg } from "../componet/Orientation/style";

function Icon() {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="35"
      fill="none"
      viewBox="0 0 36 35"
      micro="true"
    >
      <g fill="#A71B38" opacity="0.25">
        <path
          d="M34.374 9.594a.756.756 0 00-.8.8v15.987a.757.757 0 01-.8.8h-2.955a.8.8 0 100 1.6h2.955a2.357 2.357 0 002.4-2.4V10.394a.757.757 0 00-.8-.8zM4.802 4.001a.8.8 0 11-1.6 0 .8.8 0 011.6 0zM7.193 4.001a.8.8 0 11-1.6 0 .8.8 0 011.6 0zM9.594 4.001a.8.8 0 11-1.6 0 .8.8 0 011.6 0zM31.173 3.201H11.995a.756.756 0 00-.8.8.757.757 0 00.8.8h19.178a.756.756 0 00.8-.8.757.757 0 00-.8-.8z"
          opacity="0.25"
        ></path>
        <path
          d="M32.774 0H2.4a2.357 2.357 0 00-2.4 2.401v23.98a2.357 2.357 0 002.4 2.4h4.713a.8.8 0 100-1.6H2.401a.756.756 0 01-.8-.8V2.4a.756.756 0 01.8-.8h30.373a.756.756 0 01.8.8v3.992H4a.756.756 0 00-.8.8.756.756 0 00.8.8h30.373a.756.756 0 00.8-.8V2.401a2.357 2.357 0 00-2.4-2.4z"
          opacity="0.25"
        ></path>
      </g>
      <path
        fill="#A71B38"
        d="M16.708 26.513a13.97 13.97 0 01-2.163 1.345V15.706h4.748v3.517a.88.88 0 001.759 0v-3.816a1.468 1.468 0 00-1.469-1.46H9.031a1.469 1.469 0 00-1.468 1.46v7.034c0 4.459 5.9 7.088 6.094 7.167a1.399 1.399 0 001.24.026 15.192 15.192 0 002.875-1.758.88.88 0 00.167-1.24.88.88 0 00-1.231-.123z"
      ></path>
      <path
        fill="#A71B38"
        d="M26.433 21.544h-5.97a1.196 1.196 0 00-1.187 1.196V33.1a1.187 1.187 0 002.03.88l2.146-2.146 2.137 2.11c.237.226.553.349.88.343a1.179 1.179 0 001.187-1.17V22.74a1.198 1.198 0 00-1.223-1.196z"
      ></path>
    </Svg>
  );
}

export default Icon;
